import { useMemo, useState } from "react";
import { ChevronRight } from "lucide-react";
import { useI18n } from "../../../i18n";
import { useApi } from "../../customer/hooks";
import { PageHead } from "../../../components/common/Page";

// business unit > group > family, with item counts from the catalogue
const Node = ({ c, kids, counts, depth, render }) => {
  const { lang } = useI18n();
  const [open, setOpen] = useState(depth === 0);
  const children = kids(c.code);
  return (
    <li data-testid={`staff-category-${c.code}`}>
      <button type="button" onClick={() => setOpen(!open)} className="flex min-h-11 w-full items-center gap-2 rounded-lg px-2 text-left hover:bg-slate-50" style={{ paddingLeft: 8 + depth * 20 }}>
        <ChevronRight className={`h-4 w-4 shrink-0 text-slate-400 transition-transform ${open ? "rotate-90" : ""} ${children.length ? "" : "invisible"}`} />
        <span className={`min-w-0 flex-1 truncate ${depth === 0 ? "font-semibold text-navy" : "text-sm text-slate-700"}`}>{c[`name_${lang}`]}</span>
        <span className="shrink-0 rounded-full bg-canvas px-2 text-xs tabular-nums text-slate-600" data-testid={`staff-category-count-${c.code}`}>{counts[c.code] || 0}</span>
      </button>
      {open && children.length > 0 && <ul>{children.map((k) => render(k, depth + 1))}</ul>}
    </li>
  );
};

export default function StaffCategories() {
  const { t } = useI18n();
  const cats = useApi("categories", "/catalogue/categories");
  const items = useApi("staffItems", "/catalogue/items");
  const counts = useMemo(() => {
    const m = {};
    (items.data || []).forEach((i) => [i.category, i.subcategory, i.family].filter(Boolean).forEach((k) => { m[k] = (m[k] || 0) + 1; }));
    return m;
  }, [items.data]);
  const list = cats.data || [];
  const kids = (p) => list.filter((c) => (c.parent_code || null) === p);
  const render = (c, depth) => <Node key={c.code} c={c} kids={kids} counts={counts} depth={depth} render={render} />;
  return (
    <div className="max-w-3xl space-y-4" data-testid="staff-categories-page">
      <PageHead title={t("sprod.catTitle")} sub={t("sprod.catSub", { n: list.length })} />
      <ul className="rounded-2xl bg-white p-2 shadow-sm" data-testid="staff-categories-tree">{kids(null).map((c) => render(c, 0))}</ul>
    </div>
  );
}
